import { Icon } from "@clarkinc/zest-design-system";
import React, { useEffect } from "react";
import { ThunkDispatch } from "StoreTypes"; // eslint-disable-line import/no-unresolved
import Store from "~/common/Store";
import { updateUserAndChatFromOrigin } from "~/common/Store/actions/updateUserAndChatFromOrigin";
import BlogSidebar from "../BlogSidebar/BlogSidebar";

export interface BlogCategory {
  name: string;
  count: number;
  url: string;
}

interface Props {
  latestCouponPostUrl: string | undefined;
  categories: BlogCategory[];
}

export default function BlogHeader({ latestCouponPostUrl, categories }: Props) {
  const toggleSidebar = () => {
    const wrapper = document.getElementById("wrapper");

    if (!wrapper) {
      return;
    }

    const activeClassName = "active";
    if (wrapper.classList.contains(activeClassName)) {
      wrapper.classList.remove(activeClassName);
    } else {
      wrapper.classList.add(activeClassName);
    }
  };

  useEffect(() => {
    (Store.dispatch as ThunkDispatch)(updateUserAndChatFromOrigin());
  }, []);

  return (
    <div
      data-module="blogHeader"
      className="bg-[#298200] flex items-center xxxs:py-2 xxxs:px-3 md:px-8 h-[76px]"
      role="navigation"
    >
      <BlogSidebar
        latestCouponPostUrl={latestCouponPostUrl}
        categories={categories}
      />
      <div className="relative w-full">
        <div className="hidden xxxs:grid grid-cols-[1fr_auto] xxxs:items-center xxxs:w-[247px] md:h-[50px] md:w-[394px] m-0 p-0 -indent-[2000px]">
          <a
            href="/"
            className="col-span-1 bg-[url('//cdnimg.webstaurantstore.com/uploads/blog/2023/1/blog-logo2x.png')] block float-left bg-contain bg-no-repeat xxxs:h-10 xxxs:w-[217px] md:w-[304px] md:h-14"
            title="Shop WebstaurantStore"
          >
            Restaurant Supply
          </a>
          <a
            href="/blog/"
            className="col-span-1 block float-left bg-[url('//cdnimg.webstaurantstore.com/uploads/blog/2024/6/blog-logo-1x_02@2x.png')] bg-contain bg-no-repeat xxs:w-[54px] xxxs:h-10 xxxs:w-16 xxs:h-12 md:w-24 md:h-full"
            title="WebstaurantStore Blog"
          >
            Blog
          </a>
        </div>

        <div className="flex items-center absolute h-full top-0 right-3 md:right-0">
          {latestCouponPostUrl && (
            <a
              href={latestCouponPostUrl}
              className="text-white hidden xxl:flex items-center h-12 mr-4 font-proxima p-2 text-2xl border border-dashed border-white right-[84px]"
            >
              <Icon
                name="ri-scissors-line"
                className="mr-0.5 h-5 w-5 fill-white relative"
              />
              Coupon Codes
            </a>
          )}
          <button
            type="button"
            id="menu-toggle"
            className="border-transparent bg-transparent w-6 h-6"
            onClick={toggleSidebar}
          >
            <span className="sr-only">Toggle navigation</span>
            <Icon name="ri-menu-line" className="w-6 h-6 fill-white -mt-0.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
